"use client";

import { ErrorPage } from "~/common/error-page/error-page";

export default function NotFound() {
  return <ErrorPage type="404" />;
}
